import { render, staticRenderFns } from "./DashboardClinician.vue?vue&type=template&id=1d235e24&"
import script from "./DashboardClinician.vue?vue&type=script&lang=js&"
export * from "./DashboardClinician.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports